import { Box, Button } from "@mui/material";
import { ContentGalleryModal } from "@platformx/authoring-utilities";
import { ShowToastError } from "@platformx/utilities";
import { memo, useEffect, useState } from "react";
import { fetchSchemaWithData } from "../../../utils/helperFns";
import { DraggableItems } from "../DragableItem/DragableItems";
import HiddenTextBox from "../HiddenTextBox/HiddenTextBox";

const AddCollection = ({ state, setState, field, error, register, clearErrors }) => {
  const [isOpenContent, setIsOpenContent] = useState(false);

  interface PopulatedItem {
    title: string;
    name: string;
    tag_name: string;
    current_page_url: string;
  }

  const [populatedItems, setPopulatedItems] = useState<PopulatedItem[]>([]);
  const handleGalleryClose = () => {
    setIsOpenContent(false);
  };

  const handleSelectedContent = (items, name) => {
    const newArray = items?.slots?.map((val) => {
      //  return val;
      return {
        Title: val.Title,
        content_path: val.path || val.Path,
        content_name: val.page,
        CurrentPageURL: val.slug || val.Slug || val.CurrentPageURL,
        content_type: val.ContentType,
        is_hidden: false,
        type: "collection",
      };
    });
    setState({
      ...state,
      [name]: newArray,
    });
  };

  //GetSchemaData API
  const getSchema = async (Items: any) => {
    try {
      const promises = Items?.map((item) => {
        return fetchSchemaWithData(item.content_type, item.content_name, item.type);
      });
      const outputs: any = await Promise.allSettled(promises);
      const tempArray: PopulatedItem[] = [];
      outputs?.forEach((output) => {
        if (output?.status === "rejected") {
          console.error("Error in fetching row items data", output);
        } else if (output?.status === "fulfilled") {
          const schema = output?.value?.authoring_getSchemaContent || {};
          if (schema) {
            tempArray.push({
              title: schema?.title,
              name: schema?.name,
              tag_name: schema?.tag_name,
              current_page_url: schema?.current_page_url,
            });
          }
        }
      });
      setPopulatedItems(tempArray);
    } catch (err: any) {
      ShowToastError("Error in fetching row items data");
    }
  };

  useEffect(() => {
    clearErrors(field?.name);
    if (state?.[field?.name]?.length > 0) {
      getSchema(state?.[field?.name]);
    } else if (state?.[field?.name]?.length === 0) {
      setPopulatedItems([]);
    }
  }, [state?.[field?.name]]);

  return (
    <Box id={`${field?.name}_id`}>
      <Box
        sx={{
          ".draggable-category": {
            paddingRight: "0",
          },
        }}>
        <DraggableItems
          state={state}
          setState={setState}
          name={field?.name}
          populatedItems={populatedItems}
        />
      </Box>
      <Button variant='primaryButton' onClick={() => setIsOpenContent(true)}>
        {field?.placeholder}
      </Button>
      {isOpenContent ? (
        <ContentGalleryModal
          isDialogOpen={isOpenContent}
          onClose={handleGalleryClose}
          handleSelectedContent={handleSelectedContent}
          selectedItem={state[field?.name] || []}
          multi_select={field?.multiple}
          single_select={!field?.multiple}
          name={field?.name}
          allowed_content={field?.allowed_content}
          allowed_collection={field?.allowed_collection}
        />
      ) : null}
      <HiddenTextBox
        error={error}
        value={state[field?.name]?.length || ""}
        register={register}
        name={field?.name}
        required={!state[field?.name]?.length ? field?.validations[0]?.message : ""}
      />
    </Box>
  );
};

export default memo(AddCollection);
